import React from 'react';
import { UiComponents, InfoCursiveIcon } from '@simulanisindia/ui';
import chrome from '../../../assets/img/chrome.png';
import windows from '../../../assets/img/windows.png';
import googleicon from '../../../assets/img/googleicon.png';

const { SimTooltip } = UiComponents;

const LinkedAccount = () => {

    return (
        <>
            <div className="carddata colorborder">
                <div className='profileinfo'>
                    <div>
                        <h6>Linked Account</h6>
                        <p>View and manage the list of accounts that are linked with your 'Simulanis Uno' account</p>
                    </div>
                </div>
                <div className='d-flex gap-5 pt-4'>
                    <div className="linkedaccount">
                        <div>
                            <img src={googleicon} alt="" />
                        </div>
                        <div>
                            <p className='m-0'>johndoe@email.com</p>
                            <p className='m-0 duration'>1 Year ago</p>
                        </div>
                    </div>
                    <div className="linkedaccount">
                        <div className='d-flex align-items-start gap-3'>
                            <img src={chrome} alt="" />
                            <img src={windows} alt="" />
                        </div>
                        <div>
                            <p className='m-0'>
                                Ghaziabad, Uttar Pradesh, India
                                <SimTooltip text="This is a tooltip" placement="top">
                                    <span className='ms-1'><InfoCursiveIcon /></span>
                                </SimTooltip>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LinkedAccount;
